function FinalCTA() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById("pricing")
    pricingSection?.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-[#1E2B3C] to-black fade-on-scroll opacity-0">
      <div className="max-w-4xl mx-auto text-center space-y-8 sm:space-y-10">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white uppercase leading-tight">
          ХВАТИТ ТЕРПЕТЬ ХАОС.
        </h2>
        
        <p className="text-xl sm:text-2xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
          Рынок не прощает расслабленных. Возьми под контроль свой график и свой доход уже сегодня.
        </p>

        <button
          onClick={scrollToPricing}
          className="bg-[#F45B3C] text-white font-black px-10 sm:px-16 py-5 sm:py-7 rounded-lg text-xl sm:text-2xl lg:text-3xl hover:bg-[#D32F2F] transition-all duration-200 hover:shadow-2xl hover:-translate-y-1 shadow-xl uppercase inline-flex items-center gap-3"
        >
          ДА, ХОЧУ ПОРЯДОК И ДЕНЬГИ ЗА 590₽ ⚡
        </button>
      </div>
    </section>
  )
}

export default FinalCTA
